import React from 'react';

const TermsConditions = () => {
  return (
    <div className="bg-slate-50 min-h-screen font-sans pb-20">
      
      {/* ── 1. HERO BANNER ── */}
      <div className="relative text-white overflow-hidden" style={{ minHeight: '300px' }}>
        <img src="/SG (4).jpg" alt="Terms and Conditions" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#001529] via-[#0d2d6b]/90 to-[#0d2d6b]/60" />
        <div className="absolute top-0 right-0 opacity-5 text-[180px] font-black select-none leading-none -mr-8 -mt-8">SGCL</div>
        
        <div className="relative z-10 px-4 md:px-20 py-16 max-w-4xl">
          <span className="bg-govt-orange text-white px-4 py-1 rounded-full text-xs font-black uppercase tracking-widest">
            Legal &amp; Compliance
          </span>
          <h1 className="text-4xl md:text-5xl font-black mt-4 mb-5 leading-tight uppercase italic">
            Terms &amp; <span className="text-govt-orange">Conditions</span>
          </h1>
          <p className="text-blue-100 font-bold border-l-4 border-govt-orange pl-5 italic max-w-2xl leading-relaxed text-base">
            Please read these terms and conditions carefully before using our website. By accessing or using the website, you agree to be bound by these terms.
          </p>
        </div>

        {/* Tricolor border strip */}
        <div className="absolute bottom-0 left-0 right-0 h-1.5 flex">
          <div className="flex-1 bg-[#FF9933]" />
          <div className="flex-1 bg-white" />
          <div className="flex-1 bg-[#138808]" />
        </div>
      </div>

      {/* ── 2. CONTENT SECTION ── */}
      <div className="container mx-auto px-4 md:px-20 mt-12 max-w-5xl">
        <div className="bg-white rounded-3xl shadow-xl border border-slate-100 p-8 md:p-12 space-y-10 relative overflow-hidden">
          {/* Saffron accent border */}
          <div className="absolute top-0 left-0 right-0 h-1.5 bg-[#FF9933]" />

          {/* Document Header */}
          <div className="border-b border-slate-100 pb-8">
            <h2 className="text-govt-blue font-black text-2xl uppercase tracking-wider">Website Terms &amp; Conditions</h2>
            <div className="mt-4 flex flex-col md:flex-row gap-4 text-xs font-bold text-slate-500 uppercase">
              <p>🌐 <span className="text-slate-700">Websites:</span> www.shramjivicorp.com / www.shramjivicorporation.co.in</p>
              <p>🏢 <span className="text-slate-700">Owned &amp; Operated By:</span> Shramjivi Goodshed Corporation Limited</p>
            </div>
          </div>

          {/* Content sections */}
          <div className="space-y-8 text-slate-600 text-sm leading-relaxed font-semibold">
            
            {/* Section 1 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">1.</span> Acceptance of Terms
              </h3>
              <p className="pl-6">
                By accessing, browsing, or using this website, you agree to comply with and be bound by these Terms &amp; Conditions, our Privacy Policy, Disclaimer Policy, and other applicable policies published on this website.
              </p>
              <p className="pl-6 font-bold text-red-600/90 italic">
                If you do not agree with any part of these Terms &amp; Conditions, you should discontinue use of this website immediately.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 2 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">2.</span> About the Website
              </h3>
              <p className="pl-6">
                This website has been established to provide information regarding:
              </p>
              <ul className="pl-12 list-disc space-y-1 text-slate-700">
                <li>Shramjivi Goodshed Corporation Limited</li>
                <li>Railway goods shed operations</li>
                <li>Workforce management services</li>
                <li>Worker welfare initiatives</li>
                <li>Corporate information</li>
                <li>Projects and proposals</li>
                <li>Contact and communication facilities</li>
                <li>Employment and partnership opportunities</li>
              </ul>
              <p className="pl-6 text-xs text-slate-400 italic">
                Information provided on this website is intended for general informational purposes only.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 3 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">3.</span> Use of Website
              </h3>
              <p className="pl-6">
                Users agree to use this website only for lawful purposes. Users shall not:
              </p>
              <ul className="pl-12 list-disc space-y-1.5 text-slate-700">
                <li>Violate any applicable law or regulation.</li>
                <li>Upload malicious software, viruses, or harmful code.</li>
                <li>Attempt unauthorized access to website systems.</li>
                <li>Interfere with website operations.</li>
                <li>Misrepresent identity or affiliation.</li>
                <li>Submit false, misleading, or fraudulent information.</li>
                <li>Use website content for unlawful activities.</li>
              </ul>
            </section>

            <hr className="border-slate-100" />

            {/* Section 4 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">4.</span> Intellectual Property Rights
              </h3>
              <p className="pl-6">
                Unless otherwise stated, all content on this website is the property of Shramjivi Goodshed Corporation Limited and is protected under applicable copyright, trademark, and intellectual property laws. This includes:
              </p>
              <div className="pl-6 grid grid-cols-2 md:grid-cols-3 gap-3 text-xs font-bold text-slate-700 py-2">
                {['Website design', 'Logos', 'Text', 'Graphics', 'Documents', 'Reports', 'Images', 'Downloads', 'Branding materials'].map((item, idx) => (
                  <div key={idx} className="flex gap-2 items-center bg-slate-50 px-3 py-2 rounded-xl border border-slate-100">
                    <span className="text-govt-orange text-xs">•</span>
                    <span>{item}</span>
                  </div>
                ))}
              </div>
              <p className="pl-6 font-bold text-slate-700">
                No content may be copied, reproduced, distributed, modified, or commercially exploited without prior written permission from the Company.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 5 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">5.</span> Information Accuracy
              </h3>
              <p className="pl-6">
                While reasonable efforts are made to ensure that information published on this website is accurate and up-to-date, Shramjivi Goodshed Corporation Limited does not guarantee:
              </p>
              <ul className="pl-12 list-disc space-y-1 text-slate-700">
                <li>Completeness of information</li>
                <li>Accuracy of information</li>
                <li>Timeliness of information</li>
                <li>Availability of information</li>
              </ul>
              <p className="pl-6 text-xs text-slate-400 italic">
                Content may be updated, modified, or removed without prior notice.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 6 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">6.</span> Employment &amp; Registration Information
              </h3>
              <p className="pl-6">
                Any information submitted through employment forms, worker registration forms, vendor registration forms, business enquiry forms, or partnership requests must be accurate and truthful.
              </p>
              <p className="pl-6">
                The Company reserves the right to verify submitted information and reject any application containing inaccurate, misleading, incomplete, or fraudulent information.
              </p>
              <p className="pl-6 font-bold text-govt-blue">
                Submission of information does not guarantee employment, engagement, registration, partnership, or contractual approval.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 7 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">7.</span> User-Submitted Content
              </h3>
              <p className="pl-6">
                Users are solely responsible for information submitted through the website. By submitting information, users confirm that:
              </p>
              <ul className="pl-12 list-disc space-y-1 text-slate-700">
                <li>The information belongs to them or they are authorized to submit it.</li>
                <li>The information does not violate any law.</li>
                <li>The information does not infringe third-party rights.</li>
              </ul>
              <p className="pl-6">
                The Company reserves the right to remove, reject, or investigate any submitted content where necessary.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 8 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">8.</span> Third-Party Links
              </h3>
              <p className="pl-6">
                This website may contain links to external websites operated by government departments, public authorities, service providers, or other organizations. Such links are provided for convenience and informational purposes only.
              </p>
              <p className="pl-6">
                The Company does not control and is not responsible for external website content, privacy practices, security policies, or website availability. Users access external websites at their own risk.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 9 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">9.</span> Government Portal Links
              </h3>
              <p className="pl-6">
                This website may include links to official Government of India platforms, including but not limited to:
              </p>
              <ul className="pl-12 list-disc space-y-1.5 text-slate-700">
                <li>National Portal of India (<a href="https://www.india.gov.in" target="_blank" rel="noopener noreferrer" className="text-govt-blue hover:underline">https://www.india.gov.in</a>)</li>
                <li>MyGov (<a href="https://www.mygov.in" target="_blank" rel="noopener noreferrer" className="text-govt-blue hover:underline">https://www.mygov.in</a>)</li>
                <li>Integrated Government Online Directory (<a href="https://www.igod.gov.in" target="_blank" rel="noopener noreferrer" className="text-govt-blue hover:underline">https://www.igod.gov.in</a>)</li>
              </ul>
              <p className="pl-6 text-xs text-slate-400 italic">
                Such links are provided solely for informational and public-service purposes. The inclusion of such links shall not be construed as any endorsement, sponsorship, partnership, or official affiliation unless specifically stated.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 10 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">10.</span> No Government Affiliation Claim
              </h3>
              <div className="pl-6 space-y-2">
                <p>
                  Shramjivi Goodshed Corporation Limited is a private company registered under the Ministry of Corporate Affairs (MCA), Government of India.
                </p>
                <p>
                  Unless expressly stated through an official agreement or notification, the Company:
                </p>
                <ul className="pl-6 list-disc space-y-1 text-slate-700">
                  <li>Is not a government department.</li>
                  <li>Is not an agency of Indian Railways.</li>
                  <li>Does not represent the Government of India.</li>
                  <li>Does not exercise governmental authority.</li>
                </ul>
                <p className="text-xs text-slate-400 italic">
                  Any references to government initiatives, policies, or institutions are for informational purposes only.
                </p>
              </div>
            </section>

            <hr className="border-slate-100" />

            {/* Section 11 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">11.</span> Limitation of Liability
              </h3>
              <p className="pl-6">
                To the fullest extent permitted by law, Shramjivi Goodshed Corporation Limited shall not be liable for direct, indirect, incidental, consequential damages, data loss, business interruption, website downtime, or technical failures arising from use of, or inability to use, this website.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 12 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">12.</span> Website Availability
              </h3>
              <p className="pl-6">
                The Company does not guarantee uninterrupted access to the website. Access may be suspended temporarily due to maintenance, technical upgrades, security reasons, system failures, or circumstances beyond reasonable control.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 13 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">13.</span> Privacy
              </h3>
              <p className="pl-6">
                Collection and processing of personal information shall be governed by the Company's Privacy Policy available on this website. Users are encouraged to review the Privacy Policy before submitting personal information.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 14 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">14.</span> Changes to Terms &amp; Conditions
              </h3>
              <p className="pl-6">
                The Company reserves the right to modify these Terms &amp; Conditions at any time. Updated versions shall become effective immediately upon publication on the website. Continued use of the website after changes are published shall constitute acceptance of the revised Terms &amp; Conditions.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 15 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">15.</span> Governing Law &amp; Jurisdiction
              </h3>
              <p className="pl-6">
                These Terms &amp; Conditions shall be governed by the laws of India. Any disputes arising from the use of this website shall be subject to the jurisdiction of the competent courts having authority over the Company's registered office location and any other court of competent jurisdiction as permitted by law.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 16 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">16.</span> Contact Information
              </h3>
              <div className="pl-6 space-y-4">
                <p>Shramjivi Goodshed Corporation Limited</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-xs font-bold text-slate-700 bg-slate-50 p-6 rounded-2xl border border-slate-100 uppercase">
                  <div className="space-y-2">
                    <p>🌐 Website: www.shramjivicorp.com / www.shramjivicorporation.co.in</p>
                    <p>✉️ Email: support@shramjivicorp.com / info@shramjivicorporation.co.in</p>
                    <p>📞 Contact: +91 73659 61803 / +91 97070 55354</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-[10px] text-govt-orange">Registered Office:</p>
                    <p className="leading-relaxed">
                      D/14, Satyajit Roy Co-operative Market, Champasari More,<br />
                      Ward No. 46, Pradhan Nagar, Siliguri,<br />
                      Darjeeling, West Bengal – 734003
                    </p>
                  </div>
                </div>
              </div>
            </section>

          </div>

          {/* Saffron / Green tricolor banner at the bottom of card */}
          <div className="mt-10 pt-6 border-t border-slate-100 text-center text-[10px] font-black uppercase text-slate-400 tracking-widest">
            © Shramjivi Goodshed Corporation Limited. All Rights Reserved.
          </div>

        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
